import React, { useEffect, useId, useState } from "react";

import headerDefaultPicutre from "../images/header-default-picture.webp";
import "../styles/all.scss";
import "../styles/fontawesome.css";

import { Footer } from '@novaescola/eva-react-v2/lib/Footer';
import { Header } from '@novaescola/eva-react-v2/lib/Header';
import Cookies from "js-cookie";

import { Helmet } from "react-helmet";
import { AccountApi } from "../api/account/account.api";
import Alert from "./general/Alert";
import AlertNotRegistered from "./general/AlertNotRegistered";


export default function Layout({
  children,
  headerClass,
  setHasAlert,
  hasAlert,
  showAlert,
  setShowAlert,
  heroClass,
  user,
  loggedIn,
  url,
  isOpenContent
}) {
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 103);
      setShowAlert(window.scrollY < 103);
    });
  }, []);
  
  const [userDataFromApi, setUserDataFromApi] = useState(undefined)

  async function fetchUserData(bearer){
    if (bearer) {
      try {
        const response = await AccountApi.getUserData(bearer);  
        const responseProfile = await AccountApi.getProfile(bearer); 
        response.image = response.fotoPerfil !== null ? response.fotoPerfil.urlS3 : headerDefaultPicutre
        let data = {
          image: response.fotoPerfil !== null ? response.fotoPerfil.urlS3 : headerDefaultPicutre,
          admin: responseProfile.isAdmin,
          name: response.nome !== null ? response.nome : responseProfile.name
        } 
        setUserDataFromApi(data);
      } catch (err) {
        setUserDataFromApi(undefined);
      }
    }
  }

  useEffect(() => {
    const bearer = Cookies.get("Bearer");
    fetchUserData(bearer)
  }, []);

  const mainContentId = useId();
  const footerId = useId();

  return (
    <div className={`${heroClass} ${scroll ? "sticky" : ""}`}>
      
      <Alert setHasAlert={setHasAlert} showAlert={showAlert} logged={user && user.name ? true : false} />
      <Helmet>
				<link rel="preload stylesheet" href="//design.novaescola.org.br/assets/styles/eva.min.css" as="style" media="screen" />
			</Helmet>
      <Header
        mainContentId={mainContentId}
        footerId={footerId}
        user={userDataFromApi} 
        fixed={true}
        showAlert={showAlert && hasAlert}
      />
      <main role="main" id="conteudoPrincipal" >
        {/* {!loggedIn && !isOpenContent ? <AlertNotRegistered url={url} hasAlert={hasAlert} showAlert={showAlert} /> : null} */}
        {children}
      </main>
      <Footer id={footerId}	disableDonationBanner={url?.includes('/conteudo/22090/educacao-baseada-na-natureza-boas-praticas')}/>
    </div>
  );
}
